module.exports = __webpack_public_path__ + "img/certificado-2019.778ac884.jpg";